export enum Permission {
  // User Management
  USER_CREATE = 'USER_CREATE',
  USER_REMOVE = 'USER_REMOVE',
  USER_OBSOLETE = 'USER_OBSOLETE',

  // Fleet Management
  FLEET_CREATE = 'FLEET_CREATE',
  FLEET_READ = 'FLEET_READ',
  FLEET_UPDATE = 'FLEET_UPDATE',
  FLEET_DELETE = 'FLEET_DELETE',
  FLEET_LIST_ALL = 'FLEET_LIST_ALL',
  FLEET_ASSIGN = 'FLEET_ASSIGN',

  // Everyday Vehicle Inspection
  INSPECTION_CREATE = 'INSPECTION_CREATE',
  INSPECTION_READ = 'INSPECTION_READ',
  INSPECTION_UPDATE = 'INSPECTION_UPDATE',
  INSPECTION_DELETE = 'INSPECTION_DELETE',
  INSPECTION_LIST_FLEET_REPORTS = 'INSPECTION_LIST_FLEET_REPORTS',
  REPORTS_MANAGE = 'REPORTS_MANAGE',


  // Issue logging and routing
  DEVIATION_CREATE = 'DEVIATION_CREATE',
  DEVIATION_CREATE_PRODUCT = 'DEVIATION_CREATE_PRODUCT',
  DEVIATION_CREATE_OPERATION = 'DEVIATION_CREATE_OPERATION',
  DEVIATION_READ = 'DEVIATION_READ',
  DEVIATION_UPDATE = 'DEVIATION_UPDATE',
  DEVIATION_DELETE = 'DEVIATION_DELETE',
  
  // Product Info Management
  PRODUCT_INFO_UPLOAD = 'PRODUCT_INFO_UPLOAD',
}
